import ApiMixin from './api.mixin'
import BuefyMixin from './buefy.mixin'
import NavigatorMixin from './navigator.mixin'

const api = {
	mixins: [ApiMixin]
}

const buefy = {
	mixins: [BuefyMixin]
}

const navigator = {
	mixins: [NavigatorMixin]
}

export default {
	api,
	buefy,
	navigator
}
